import type { AssistantChatGenqlSelection } from '@rematter/frontend-lib-api-client';

export const assistantChatFragment = {
  __typename: true,
  id: true,
  title: true,
  status: true,
  userId: true,
  organizationId: true,
  agentId: true,
  isShared: true,
  timestamps: {
    createdAt: true,
    updatedAt: true,
  },
} as const satisfies AssistantChatGenqlSelection;

export const assistantChatWithAgentFragment = {
  ...assistantChatFragment,
} as const satisfies AssistantChatGenqlSelection;
